import React from 'react';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from 'App';
import { AppProvider } from "contexts/AppContext";
import { AuthProvider } from 'contexts/AuthContext';
import InjectAxios from "components/InjectAxios";
// Import PrimeReact core CSS and icons
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

// Import additional CSS for components (if needed)
import 'primeflex/primeflex.css'; // Optional for layout utility classes
import './i18n';
import "./index.scss";

const container = document.getElementById('root');
const root = createRoot(container);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: Infinity
    },
  },
});

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
      <AppProvider>
        <InjectAxios />
        <App />
      </AppProvider>
      </AuthProvider>
    </QueryClientProvider>
  </BrowserRouter>
  // </React.StrictMode>
);